import { render, staticRenderFns } from "./TagPills.vue?vue&type=template&id=45f82fdb&"
import script from "./TagPills.vue?vue&type=script&lang=js&"
export * from "./TagPills.vue?vue&type=script&lang=js&"
import style0 from "./TagPills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports